export const DESIGN_TABS = [
  {
    name: 'Interior',
    paragraphs: [
      {
        title: '',
        description: 'There is one overwhelming constant in Bezzina’s approach to development – the location inspires the design. Because we take so much care in selecting our waterfront properties it is only natural that our apartments should pay homage to the surroundings.'
      },
      {
        title: '',
        description: 'It guarantees also that each property is unique, the clean elegant lines of the architecture responding to its environment. The result is a style of architecture that looks right in its place, offering a daily reminder that life is indeed good.'
      },
      {
        title: '',
        description: 'Our preference for natural materials, sandstone, marble and timber, and our deference to the craft of the artisan, lends a feeling of permanence and warmth to our apartments, a rare feat in a machine age.'
      }
    ]
  },
  {
    name: 'Landscape'
  },
  {
    name: 'Materials'
  },
  {
    name: 'Lifestyle'
  }
]



// WEBPACK FOOTER //
// ./src/store/design_tabs.js